import { HttpClient, HttpParams } from "@angular/common/http";
import { S3File } from "allai-admin-shared";
import { firstValueFrom } from "rxjs";
import { environment } from "../../environments/environment";
import { Injectable } from "@angular/core";
import { saveAs } from "file-saver-es";

@Injectable({
	providedIn: 'root'
})
export class FileService {

	constructor(private http: HttpClient) {
	}

	async download(file: S3File): Promise<void> {
		let params = new HttpParams();
		params = params.set("bucket",file.bucket);
		params = params.set("key",file.key);

		const path = file.key.split("/");
		const fileName = path[path.length-1];

		const url = await firstValueFrom(this.http.get(`${environment.apiUrl}/download`,{params}));
		this.http.get((url as any).url,{responseType: "blob"}).subscribe(data => saveAs(data,fileName));
	}
}
